<template>
  <div class="page-box">
    <div class="top-box" v-if="user !=='' ">剩余金额:{{remainAmount}}元</div>
    <div class="line-box">
      <span>缴费类型</span>
      <el-radio-group v-model="payType">
          <el-radio class="choose-radio" label="1">电</el-radio>
          <el-radio label="2">水</el-radio>
      </el-radio-group>
    </div>
    <div class="line-box">
      <span><i>*</i> 选择用户</span>
      <el-select size="small" v-model="user" placeholder="请选择用户">
        <el-option v-for="item in usersList" :key="item.name" :label="item.name" :value="item.value"></el-option>
      </el-select>
    </div>
    <div class="line-box">
      <span><i>*</i> 充值金额</span>
      <el-input-number size="small" v-model="rechargeAmount" :min="1" ></el-input-number>
    </div>
    <div class="button-box">
      <button class="fun" @click="submit()">提交</button>
      <button class="fun" @click="setRate()">设置费率</button>
    </div>
    <el-dialog title="设置电费率" :visible.sync="electricDiolog" width="35%">
      <el-form ref="form" :model="electricForm" label-width="50px">
        <el-form-item label="峰段">
          <el-input v-model="electricForm.peakSection"></el-input>
        </el-form-item>
        <el-form-item label="平段">
          <el-input v-model="electricForm.flatSection"></el-input>
        </el-form-item>
        <el-form-item label="谷段">
          <el-input v-model="electricForm.valleySection"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="electricDiolog = false">取 消</el-button>
        <el-button type="primary" >保存</el-button>
      </span>
    </el-dialog>
    <el-dialog title="设置水费率" :visible.sync="waterDiolog" width="35%">
      <el-form ref="form" :model="waterForm" label-width="130px">
        <el-form-item label="标准水量">
          <el-input v-model="waterForm.standard"></el-input>
        </el-form-item>
        <el-form-item label="超出标准水量20%">
          <el-input v-model="waterForm.littleMore"></el-input>
        </el-form-item>
        <el-form-item label="超出标准水量40%">
          <el-input v-model="waterForm.lotMore"></el-input>
        </el-form-item>
      </el-form>
      <span class="dialog-footer">
        <el-button @click="waterDiolog = false">取 消</el-button>
        <el-button type="primary" >保存</el-button>
      </span>
    </el-dialog>
    <el-dialog title="充值信息" :visible.sync="submitDiolog" width="35%">
      <ul>
        <li>缴费类型：</li>
        <li>缴费用户：</li>
        <li>缴费金额：元</li>
        <li>剩余金额：元</li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" >打印</el-button>
        <el-button @click="submitDiolog = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "rechargePayment",
  data() {
    return {
      remainAmount: 0,
      payType: "1",
      user: "",
      rechargeAmount: "",
      electricDiolog: false,
      waterDiolog: false,
      submitDiolog: false,
      electricForm: { peakSection: 1.1902, flatSection: 1.1902, valleySection: 1.1902 },
      waterForm: { standard: 9.5, littleMore: 19, lotMore: 28.5},
      usersList: [
        { name: " 于国云小吃", value: "1"},
        { name: "宇通招待所", value: "2"},
        { name: "西院理发店", value: "3"},
        { name: "于国云车库", value: "4"},
      ]
    }
  },
  mounted() {

  },
  methods: {
    submit() {
      this.submitDiolog = true;
    },
    setRate() {
      if(this.payType === "1") {
        this.electricDiolog = true;
      } else {
        this.waterDiolog = true;
      }
    }
  }
}
</script>
<style scoped lang="scss">
.page-box {
  padding: 30px 30px 525px;
  margin-bottom: 20px;
  .top-box {
    margin-bottom: 20px;
    font-size: 24px;
    color: #7bf8fa;
  }
  .line-box {
    margin-bottom: 20px;
    span {
      display: inline-block;
      width: 90px;
      margin-right: 10px;
      font-size: 14px;
      text-align: right;
      color: #fff;
      i {
        color: #f56c6c;
      }
    }
    .choose-radio {
      margin-right: 60px;
    }
  }
  .button-box {
    padding-left: 100px;
  }
}
@media screen and (width:3440px) and (height: 1440px )   {
  .page-box{
    margin: 0 auto;
    width: 400px;
  }
    }
    @media screen and (width:3840px) and (height: 1080px )   {
      .page-box{
    margin: 0 auto;
    width: 400px;
  }
    }
</style>
